export default __webpack_public_path__ + "static/media/ill-no-data.0e522bd9.svg";